import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">Reta 1</h1>
      </div>
    </section>
  );
};

export default Hero;
